(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/api-proxy/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/components/lb-utils/api-proxy/assets/javascripts/constants.js');
"use strict";


const HTTP_METHOD = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
  HEAD: 'HEAD',
  OPTIONS: 'OPTIONS'
};
const HTTP_METHODS = Object.values(HTTP_METHOD);
const FEATURE_TOGGLE = {
  BOMBEN_DRAWS_CLOUD_API: 'ft-bomben-draws-cloud-api',
  MARKETPLACE_PAM_CORE_CLOUD_API: 'ft-marketplace-pam-core-cloud-api'
};
const constantsExport = {
  HTTP_METHOD,
  HTTP_METHODS,
  FEATURE_TOGGLE
};
if (svs.isServer) {
  module.exports = constantsExport;
} else {
  setGlobal('svs.components.lbUtils.apiProxy.constants', constantsExport);
}

 })(window);